<template>
  <div class="flex flex-col w-full h-full overflow-hidden bg-n-background dark:bg-n-black">
    <header class="sticky top-0 z-10 px-6 bg-n-background dark:bg-n-black h-5 shrink-0 w-full" />
    <main class="flex-grow overflow-auto px-6 bg-n-surface-1 rounded-t-2xl">
      <div class="max-w-5xl mx-auto pb-12 pt-4">
        <div class="flex items-center justify-between w-full h-12 mb-4 border-b border-n-weak pb-2">
          <span class="text-xl font-medium text-n-slate-12">Reports</span>
        </div>
        <router-view />
      </div>
    </main>
  </div>
</template>
